import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import { Toast, Button, CountDown, Loading, Dialog, Swipe, SwipeItem } from 'vant';
import LoadingDirective from './directives/loading';

Vue.config.ignoredElements = [
	'wx-open-launch-app',
	'wx-open-launch-weapp'
]

Vue.config.productionTip = false

Vue.use(VueClipboard);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(Button);
Vue.use(CountDown);
Vue.use(Dialog);
Vue.use(Swipe);
Vue.use(SwipeItem);

Vue.directive('loading', LoadingDirective);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
